import { http } from 'utils'

// Category mutation imports.
import { SET_CATEGORIES } from 'vx/mutations'

// Category state.
const state = {
  categories: []
}

// Category state getters.
const getters = {}

// Category actions.
const actions = {
  /**
   * Get all categories.
   *
   * @return Promise
   */
  getCategories ({ commit }, params = {}) {
    return http.get('categories', { params })
      .then((response) => {
        commit(SET_CATEGORIES, response.data)

        return response
      })
  }
}

// Category state mutations.
const mutations = {
  [SET_CATEGORIES] (state, categories) {
    state.categories = categories
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
